import React from "react";
import PropTypes from "prop-types";
import Image from "../global/Image";
import SmartWidth from "../../utils/ImageWidthHandler";

/********************************
<Logo />
/********************************
Version: 1
Created: 16 08 2023
Updated: 19 02 2025
Author: Richy Pears
/********************************
Returns a logo, wrapped in a link
if it has one, for use in the
<Logos /> components

TODO: For some reason the xl:w-1/7
and higher numbers are not working/
registering
/********************************/

const Logo = ({ columns, node }) => {
  if (!node) return null; // Escape hatch

  const imageWidth = SmartWidth(columns && columns, "width"); // This returns optimum widths for our images

  return (
    <div
      className={`flex flex-col p-6 shrink-0 grow-0 
      ${
        columns?.xs && columns?.xs !== "auto"
          ? ` w-1/${columns.xs} shrink-0`
          : ``
      }
      ${
        columns?.sm && columns?.sm !== "auto"
          ? ` sm:w-1/${columns.sm} sm:shrink-0`
          : ``
      }
      ${
        columns?.md && columns?.md !== "auto"
          ? ` md:w-1/${columns.md} md:shrink-0`
          : ``
      }
      ${
        columns?.lg && columns?.lg !== "auto"
          ? ` lg:w-1/${columns.lg} lg:shrink-0`
          : ``
      }
      ${
        columns?.xl && columns?.xl !== "auto"
          ? ` xl:w-1/${columns.xl} xl:shrink-0`
          : ``
      }
    `}
    >
      <div className="flex flex-col gap-3 items-center justify-center text-center">
        {node.logo && (
          <span
            className="m-0 aspect-square bg-grey rounded-full shadow-glow"
            style={{
              color: node.glow ? node.glow?.color : "white",
            }}
          >
            <Image
              aspect="1x1"
              src={node.logo}
              sizes={imageWidth}
              className={`rounded-full w-full shadow-award`}
            />
          </span>
        )}
        {node.name && <p className="m-0 text-xs">{node.name}</p>}
      </div>
    </div>
  );
};

export default Logo;

Logo.defaultProps = {
  columns: null,
  node: null,
};

Logo.propTypes = {
  columns: PropTypes.object,
  node: PropTypes.object,
};
